module.exports = __webpack_public_path__ + "img/gas.bef270c0.svg";